import React from 'react';
import PropTypes from 'prop-types';
import { useAdvanceTableContext } from '../../../providers/AdvanceTableSearchProvider';
import { flexRender } from '@tanstack/react-table';
import classNames from 'classnames';

const AdvanceTableCustom = ({
    headerClassName,
    bodyClassName,
    rowClassName,
    tableProps
}) => {

    const table = useAdvanceTableContext();
    const { getRowModel, getFlatHeaders } = table;

    return (
        <div className="w-full border rounded-md">
            <div style={{ maxHeight: '450px', overflowY: 'auto', overflowX: 'auto' }}>
                <table className='mb-0 table align-middle table-striped' style={{ width: '100%' }}>
                    <thead
                        className={classNames(headerClassName, 'align-middle')}
                        style={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 2
                        }}
                    >
                        <tr className='text-start'>
                            {getFlatHeaders().map(header => {
                                const hProps = header.column.columnDef.meta?.headerProps || {};
                                return (
                                    <th
                                        key={header.id}
                                        style={hProps.style}
                                        className={classNames(
                                            hProps.className || '',
                                            {
                                                sort: header.column.getCanSort(),
                                                desc: header.column.getIsSorted() === 'desc',
                                                asc: header.column.getIsSorted() === 'asc'
                                            }
                                        )}
                                        onClick={header.column.getToggleSortingHandler()}
                                    >
                                        {header.isPlaceholder
                                            ? null
                                            : flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody>
                        {getRowModel().rows.map(row => {
                            const cellProps0 = row.getVisibleCells()[0]?.column.columnDef.meta?.cellProps || {};
                            return (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map(cell => {
                                        const cellProps = cell.column.columnDef.meta?.cellProps || {};
                                        return (
                                            <td
                                                key={cell.id}
                                                style={cellProps.style}
                                                className={classNames(
                                                    'alert-row',
                                                    cellProps.className
                                                )}
                                            >
                                                {flexRender(
                                                    cell.column.columnDef.cell,
                                                    cell.getContext()
                                                )}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

AdvanceTableCustom.propTypes = {
    headerClassName: PropTypes.string,
    bodyClassName: PropTypes.string,
    rowClassName: PropTypes.string,
    tableProps: PropTypes.object
};

export default AdvanceTableCustom;
